import { render, staticRenderFns } from "./PermissionConfig.vue?vue&type=template&id=868cd096&scoped=true"
import script from "./PermissionConfig.vue?vue&type=script&lang=js"
export * from "./PermissionConfig.vue?vue&type=script&lang=js"
import style0 from "./PermissionConfig.vue?vue&type=style&index=0&id=868cd096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868cd096",
  null
  
)

export default component.exports